export const SettingUrls = {
    shippingProviders: '/setting/shipping-providers',
    shippingZones: '/setting/shipping-zones',
    paymentMapping: '/setting/payment-mapping',
    designSettings: '/setting/integration-mode/design-settings',
    integrationMode: '/setting/integration-mode',
    billing: '/billing',
    dashboard: '/',
    wizard: '/dashboard/steps',
    orders: '/orders',
    settingsProfile: '/setting/profile',
    checkoutSettings: '/setting/integration-mode/checkout-settings',
    checkoutMapSettings: '/setting/integration-mode/checkout-map-settings',
    thankYouPageMapSettings: '/setting/integration-mode/after-checkout-map-settings',
    billingThankYou: '/billing/thank-you',
    currentSubscription: '/billing-subscription',
    apps: '/apps',
    appsOtp: '/apps/otp',
};

export const SettingsProfileUrls = {
    orderAttributes: `${SettingUrls.settingsProfile}/order-attributes`,
};
